// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ISetQuestionReactionWebRequest,
  TSetQuestionReactionWebModel,
  IMappers,
  TSetQuestionReactionWebResponse,
  ISetQuestionReactionWebResponse,
  ISetQuestionReactionWebResponseError,
} from './types';

export const defaultConfig: TSetQuestionReactionWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-reviews',
  pathApi: '/v1/set-question-reaction-web/',
  requestType: 'json',
} as TSetQuestionReactionWebModel;

export function createSetQuestionReactionWebModel(
  parameters: ISetQuestionReactionWebRequest,
): TSetQuestionReactionWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ISetQuestionReactionWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ISetQuestionReactionWebRequest;
}

export async function fetchSetQuestionReactionWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISetQuestionReactionWebOptions<TResponse200, TResponse400>): Promise<
  TSetQuestionReactionWebResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createSetQuestionReactionWebModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISetQuestionReactionWebResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ISetQuestionReactionWebResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TSetQuestionReactionWebResponse;
}
